import React from 'react';
import { Routes } from 'react-router-dom';
import {
  AdminProtectedRoutes,
  AdminSubdomainEntry,
  ApexPublicRoutes,
  CompanyGuestRoutes,
  CompanyProtectedRoutes,
  CustomerRoutes,
  MerchantPathRoutes,
  MerchantSubdomainAuthRoutes,
  MerchantSubdomainGuestRoutes,
  RiderSubdomainAuthRoutes,
  RiderSubdomainGuestRoutes,
  RiderLegacyPathRedirects,
  UtilityRoutes,
  NotFoundRoute,
} from './routes';

/**
 * Route modules return Fragment-wrapped <Route> elements.
 * Invoke as functions inside <Routes><>...</></> — RR v6 rejects custom components as direct children.
 */
function routeTree(...parts) {
  return (
    <>
      {parts.map((part, i) => {
        const key = typeof part === 'function' ? (part.name || `route-${i}`) : `route-${i}`;
        return (
          <React.Fragment key={key}>
            {typeof part === 'function' ? part() : part}
          </React.Fragment>
        );
      })}
    </>
  );
}

/** admin.dev-shipping.fikrnova.tech */
export function AdminHostRoutes({ isAuthenticated }) {
  return (
    <Routes>
      {routeTree(
        () => AdminSubdomainEntry({ isAuthenticated }),
        AdminProtectedRoutes,
        RiderLegacyPathRedirects,
        UtilityRoutes,
        NotFoundRoute,
      )}
    </Routes>
  );
}

/** rider-{slug}.dev-shipping.fikrnova.tech */
export function RiderHostRoutes({ isAuthenticated }) {
  return (
    <Routes>
      {routeTree(
        isAuthenticated ? RiderSubdomainAuthRoutes : RiderSubdomainGuestRoutes,
        UtilityRoutes,
        NotFoundRoute,
      )}
    </Routes>
  );
}

/** merchant-{slug}.dev-shipping.fikrnova.tech */
export function MerchantHostRoutes({ isAuthenticated }) {
  return (
    <Routes>
      {routeTree(
        isAuthenticated ? MerchantSubdomainAuthRoutes : MerchantSubdomainGuestRoutes,
        UtilityRoutes,
        NotFoundRoute,
      )}
    </Routes>
  );
}

/** customer-{slug}.algeza-delivery.fikrnova.tech */
export function CustomerHostRoutes({ isAuthenticated, user }) {
  const isCustomer = isAuthenticated && user?.type === 'customer';
  return (
    <Routes>
      {routeTree(
        () => CustomerRoutes({ isCustomer }),
        UtilityRoutes,
        NotFoundRoute,
      )}
    </Routes>
  );
}

/** {slug}.dev-shipping.fikrnova.tech — authenticated company staff */
export function CompanyAuthRoutes() {
  return (
    <Routes>
      {routeTree(
        AdminProtectedRoutes,
        MerchantPathRoutes,
        RiderLegacyPathRedirects,
        CompanyProtectedRoutes,
        UtilityRoutes,
        NotFoundRoute,
      )}
    </Routes>
  );
}

/** {slug}.dev-shipping.fikrnova.tech — guest (role prompt) */
export function CompanyGuestHostRoutes() {
  return (
    <Routes>
      {routeTree(CompanyGuestRoutes, UtilityRoutes, NotFoundRoute)}
    </Routes>
  );
}

/** Apex / localhost — landing + legacy path-based portals */
export function ApexHostRoutes({ isAuthenticated, getDefaultRoute }) {
  return (
    <Routes>
      {routeTree(
        () => ApexPublicRoutes({ isAuthenticated, getDefaultRoute }),
        RiderLegacyPathRedirects,
        UtilityRoutes,
        AdminProtectedRoutes,
        MerchantPathRoutes,
        CompanyProtectedRoutes,
        NotFoundRoute,
      )}
    </Routes>
  );
}